angular.module('rjmNg.api').factory("GoogleAnalytics", [
  "$resource"
  "phpServiceUrl"
  ($resource, phpServiceUrl) ->

    defaultParams =
      isArray: true
      cache: true

    actions =
      getMetrics: angular.extend {}, defaultParams,
        url: phpServiceUrl("/client/:clientId/trend/galist")
      getDimensions: angular.extend {}, defaultParams,
        url: phpServiceUrl("/client/:clientId/trend/gaslicers")
      getMetricDimensions: angular.extend {}, defaultParams,
        url: phpServiceUrl("/client/:clientId/trend/:metricId/gaslicers")

    GA = $resource("", {}, actions)

    getMetrics = (clientId) ->
      GA.getMetrics({clientId}).$promise

    getDimensions = (clientId) ->
      GA.getDimensions({clientId}).$promise

    getMetricDimensions = (clientId, metricId) ->
      GA.getMetricDimensions({clientId, metricId}).$promise

    {
      getMetrics
      getDimensions
      getMetricDimensions
    }
  ]
)
